
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/FAB",
      function () {
        return require("private-next-pages/FAB.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/FAB"])
      });
    }
  